/**
 * Client API pour le service Communication (via Gateway)
 */

import { HttpClient } from '@sphere/shared/data-access/http'
import type {
  AnnouncementResponse as Announcement,
  ListAnnouncementsQueryDto as AnnouncementQuery,
  CreateAnnouncementDto,
  PaginatedAnnouncementsResponse,
  UpdateAnnouncementDto,
  AnnouncementModuleCapabilities,
} from '@sphere/communication/domain'
import type {
  CreateEmailDto,
  EmailResponse,
  ListEmailsQueryDto,
  PaginatedEmailsResponse,
} from '@sphere/communication/domain'

export const communicationClient = {
  // ---------------------------------------------------------------------------
  // Announcements
  // ---------------------------------------------------------------------------

  announcements: {
    list: (params: AnnouncementQuery = {}) =>
      HttpClient.get<PaginatedAnnouncementsResponse>(
        '/communication/announcements',
        { params }
      ),

    getById: (id: string) =>
      HttpClient.get<Announcement>(`/communication/announcements/${id}`),

    create: (data: CreateAnnouncementDto) =>
      HttpClient.post<Announcement>('/communication/announcements', data),

    update: (id: string, data: UpdateAnnouncementDto) =>
      HttpClient.put<Announcement>(`/communication/announcements/${id}`, data),

    delete: (id: string) =>
      HttpClient.delete<void>(`/communication/announcements/${id}`),

    markAsRead: (id: string) =>
      HttpClient.post<void>(`/communication/announcements/${id}/read`),

    unreadCount: () =>
      HttpClient.get<{ count: number }>(
        '/communication/announcements/unread-count'
      ),

    capabilities: () =>
      HttpClient.get<AnnouncementModuleCapabilities>(
        '/communication/announcements/capabilities'
      ),
  },

  // ---------------------------------------------------------------------------
  // Emails
  // ---------------------------------------------------------------------------

  emails: {
    list: (params: ListEmailsQueryDto = {}) =>
      HttpClient.get<PaginatedEmailsResponse>('/communication/emails', {
        params,
      }),

    send: (data: CreateEmailDto) =>
      HttpClient.post<EmailResponse>('/communication/emails', data),
  },
}
